<template>
  <div class="loading"></div>
</template>

<script>
export default {
  name: "Loading" // 定义的组件名称 使用时写法：loading
};
</script>

<style lang="less" scoped>
.loading {
  position: fixed;
  // left: 160px;
  // top: 85px;
  background: url("../../../assets/Images/timg.gif") center center no-repeat
    #fff;
  width: 100%;
  height: 95%;
  z-index: 1999;
  top: 87px;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/laoding/index.vue